/**
 * White Label Utility Functions
 * These functions help detect and handle white label domains
 */

/**
 * Check if current domain is a potential white label domain
 * This works before any API calls are made
 */
export const isPotentialWhiteLabelDomain = () => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;

  // List of legitimate Zoobbe subdomains that are NOT white label
  const legitimateSubdomains = [
    'app.zoobbe.com',
    // 'www.zoobbe.com',
    'beta.zoobbe.com',
    'api.zoobbe.com',
    'api-v1.zoobbe.com',
    'admin.zoobbe.com',
    'cdn.zoobbe.com',
    'assets.zoobbe.com',
    'mail.zoobbe.com',
    'support.zoobbe.com',
    'help.zoobbe.com',
    'docs.zoobbe.com',
    'blog.zoobbe.com',
    'status.zoobbe.com',
    'dev.zoobbe.com',
    'staging.zoobbe.com',
    'prod.zoobbe.com',
    'production.zoobbe.com',
    'demo.zoobbe.com',
    'sandbox.zoobbe.com',
    'portal.zoobbe.com',
    'localhost'
  ];

  // Check if it's a subdomain of zoobbe.com but not a legitimate one
  if (hostname.endsWith('.zoobbe.com') && !legitimateSubdomains.includes(hostname)) {
    return true;
  }

  // Check if it's a custom domain (not zoobbe.com at all)
  if (!hostname.includes('zoobbe.com') && !hostname.includes('localhost')) {
    return true;
  }

  return false;
};

/**
 * Get the subdomain from current hostname
 */
export const getCurrentSubdomain = () => {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;

  if (hostname.endsWith('.zoobbe.com')) {
    return hostname.split('.')[0];
  }

  return null;
};

/**
 * Check if we're in development mode with localhost
 */
export const isLocalDevelopment = () => {
  if (typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname.startsWith('localhost:') ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('127.0.0.1:')
  );
};

/**
 * Get a safe title for potential white label domains before API response
 */
export const getSafeTitleForWhiteLabel = () => {
  if (typeof window === 'undefined') return 'Zoobbe';

  const hostname = window.location.hostname;

  // For localhost, always return Zoobbe
  if (isLocalDevelopment()) {
    return 'Zoobbe';
  }

  // For potential white label domains, try to create a nice title
  if (isPotentialWhiteLabelDomain()) {
    if (hostname.endsWith('.zoobbe.com')) {
      // For subdomains, capitalize the subdomain
      const subdomain = hostname.split('.')[0];
      return subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
    } else {
      // For custom domains, use the domain name
      const domainParts = hostname.split('.');
      if (domainParts.length >= 2) {
        const mainDomain = domainParts[domainParts.length - 2];
        return mainDomain.charAt(0).toUpperCase() + mainDomain.slice(1);
      }
    }
  }

  return 'Zoobbe';
};